export default __webpack_public_path__ + "static/Infodesign-79bbbd9e95d8037f1151d73db5e6f89e.png";